import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import BottomAccordion from '../../../shared/bottom-accordion/content';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

export default function Accordion(props) {
  let aboutThisPageMarkup = (
    <div>
      <i className="ui icon info circle mrls mrrnull text-size-xl fr mrbs" />
      <p>
        {htmlToReactParser.parse(
          xss(`<b>${APP.LANGUAGE.ViewMeetingRoom.Title}</b> ${APP.LANGUAGE.ViewMeetingRoom.InfoPartOne}`)
        )}
      </p>
      <p>{htmlToReactParser.parse(xss(APP.LANGUAGE.ViewMeetingRoom.InfoPartTwo))}</p>
      <p>{htmlToReactParser.parse(xss(APP.LANGUAGE.ViewMeetingRoom.InfoPartThree))}</p>
    </div>
  );

  let options = [
    {
      title: 'Test My equipment',
      as: 'testCallBtn',
      link: `ce/?testonly=true`,
    },
    {
      title: 'About this page',
      as: 'custom',
      content: aboutThisPageMarkup,
    },
  ];
  let activeIndexOfPage = window.localStorage.getItem(`mrActiveIndex-${props.userId}`);

  return (
    <BottomAccordion
      options={options}
      userId={props.userId}
      className="dark-accordion-divider"
      id="meeting-rooms-accordion"
      boldTitle={true}
      renderTestCallBtn={true}
      pagePrefix="mrActiveIndex"
      activeIndex={
        (!!activeIndexOfPage && JSON.parse(activeIndexOfPage)) || [
          options[0].title.split(' ').join(''),
          options[options.length - 1].title.split(' ').join(''),
        ]
      }
    />
  );
}
